import * as React from 'react';
import { OtherDevelopersWrapper } from '../../components/OtherDevelopersRedesigned';
import { useSelector } from 'react-redux';
import { getOtherDevelopers } from '../../selectors/developerV2/getOtherDevelopers';
import { OtherDeveloperCard } from '../../components/OtherDevelopersRedesigned/OtherDeveloperCard';
import { trackOtherDevelopersClick, trackOtherDevelopersShow } from './tracking';

export const OtherDevelopers = () => {
  const developers = useSelector(getOtherDevelopers);

  if (developers.length === 0) {
    return null;
  }

  return (
    <OtherDevelopersWrapper onShow={trackOtherDevelopersShow}>
      {developers.map(developer => (
        <OtherDeveloperCard
          key={developer.id}
          logo={developer.logo}
          rate={developer.rating}
          name={developer.name}
          url={developer.url}
          readyHouses={developer.readyHouses}
          housesInProcess={developer.housesInProcess}
          onClick={() => trackOtherDevelopersClick(developer.id)}
        />
      ))}
    </OtherDevelopersWrapper>
  );
};
